import { AnimatePresence } from "framer-motion";
import { TicketCard } from "./TicketCard";
import { Siren } from "lucide-react";

export function SOSStrip({ tickets }) {
  if (!tickets || tickets.length === 0) return null;

  return (
    <div
      data-testid="sos-strip"
      className="w-full flex items-center gap-3 px-5 py-2.5 bg-gradient-to-r from-red-950/20 via-red-950/10 to-red-950/20 border-b border-red-500/25 shrink-0"
    >
      <div className="flex flex-col items-center gap-0.5 shrink-0 mr-2">
        <Siren className="w-5 h-5 text-red-400 blink" strokeWidth={2} />
        <span className="font-display text-[10px] font-bold text-red-400 tracking-[0.2em]">SOS</span>
      </div>
      <div className="flex gap-3 overflow-hidden flex-1">
        <AnimatePresence mode="popLayout">
          {tickets.slice(0, 5).map(t => (
            <TicketCard key={t.id} ticket={t} variant="sos" />
          ))}
        </AnimatePresence>
      </div>
      {tickets.length > 5 && (
        <span className="text-xs text-red-400 shrink-0 font-display">+{tickets.length - 5} more</span>
      )}
    </div>
  );
}
